'use strict';

/*
Name: Tables
*/

class Tables {
  constructor () {
    if (document.querySelector('.field--body table thead')) {
      this.tables = document.querySelectorAll('.field--body table');
      for (var i = 0; i < this.tables.length; i++) {
        if (this.tables[i].querySelector('thead')) {
          let thead = this.tables[i].querySelectorAll('thead th');
          let rows = this.tables[i].querySelectorAll('tbody tr');
          this.tables[i].classList.add('mobilized');
          for (var r = 0; r < rows.length; r++) {
            let cells = rows[r].querySelectorAll('td');
            for (var t = 0; t < thead.length; t++) {
              cells[t].setAttribute('data-label', thead[t].innerHTML);
            }
          }
        }
      }
    }
  }
}
module.exports = Tables;
